export default __webpack_public_path__ + "static/media/kml-icon.a74005c0.svg";